<script>

export default {
  name: 'Redirect',

  props: {
    kind: {
      type: String,
      required: true
    }
  },

  watch: {
    teamsiteConfig () {
      if (this.routes[this.kind]) {
        location.href = this.routes[this.kind]
      } else {
        location.href = '/'
      }
    }
  }
}
</script>

<template>
  <div class="row redirect">
    <div class="medium-16 medium-centered text-center">
      Sie werden nun weitergeleitet...
    </div>
  </div>
</template>

<style lang="scss" scoped>
.redirect {
  padding: 50px 0;
  min-height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/components/Redirect.vue